import * as React from 'react';
import Card from '../../layout/card/Card';
import { css } from '@emotion/core';
import CardHeader from '../../layout/card/CardHeader';
import { FLEX_COLUMN } from '../../layout/flexBox';
import { Link } from 'react-router-dom';
import { Routes } from '../../navigation/routes';
import { btnStyle } from '../../forms/styles/button';
import { COLORS } from '../../globalStyle/colors';
import { useMsgText } from '../../localization/hooks';
import { Str } from '../../localization/translationKeys';
import Msg from '../../localization/Msg';
import { isDevResources, isTutorialResource } from './module';
import { CustomResource } from './models';


const styles = {
  root:         css`
  `,
  header:       css`
    margin-bottom: 20px;
  `,
  cardContent:  css`
    align-items: stretch; 
    margin-top: 20px;
  `,
  btnContainer: css`
    & > span {
      display: block;
    }
    & > * {
      margin-bottom: 6px;
    }
    & > *:last-child {
      margin-bottom: 0;
    }
  `,
  resourceLink: btnStyle.primary(COLORS.BLUE),
};


type Props = {
  routes: Routes;
  resources: CustomResource[] | undefined;
  className?: string;
};


const renderResource = (routes: Routes, resource: CustomResource): React.ReactNode => {
  if (isDevResources(resource)) {
    return (
      <Link key='DevResources' to={routes.DevResources} css={styles.resourceLink}>
        <Msg str={Str.DevResources} />
      </Link>
    );
  }

  if (isTutorialResource(resource)) {
    return (
      <Link key='ReportTutorial' to={routes.ReportTutorial} css={styles.resourceLink}>
        <Msg str={Str.ReportTutorial} />
      </Link>
    );
  }

  return (
    <Link 
      key={resource.nameMessageId}
      to={routes.CustomResource + '/' + resource.nameMessageId}
      css={styles.resourceLink}
    >
      <span>{resource.nameText}</span>
    </Link>
  );
};

/**
 * ProjectResources: a component that renders a card with a list of resource links, including special cases for Dev
 * Resources and Video Tutorial
 *
 * PureComponent: true
 * Redux Connected: false
 */
const ProjectResources: React.FC<Props> = props => {
  const title = useMsgText(Str.Resources);

  if (!props.resources || props.resources.length === 0) {
    return <div className={props.className} />;
  }

  return (
    <Card css={[styles.root]} className={props.className}>
      <CardHeader title={title} css={styles.header} />
      <div css={[FLEX_COLUMN, styles.btnContainer]}>
        {
          props.resources.map(res => renderResource(props.routes, res))
        }
      </div>
    </Card>
  );
};

export default ProjectResources;
